import { READ_ACTION, ORGANIZATION_CHART, CONSULTANT_RESOURCE, EMPLOYEE_MENU } from "@/constants/resources";

export default [
  {
    title: "Departamentos",
    icon: "none",
    children: [
      {
        title: "Colaboradores",
        route: "employee-list",
        icon: "UsersIcon",
        resource: EMPLOYEE_MENU,
        action: READ_ACTION,
      },
      {
        title: "Organograma",
        href: "https://www.canva.com/design/DAFA5MuTqJM/wvuDYbPN5rCDmD-L4xOIQw/view",
        icon: "BarChart2Icon",
        resource: ORGANIZATION_CHART,
        action: READ_ACTION,
      },
    ],
  },
];
